const reasons = [
  {
    icon: "ri-eye-line",
    title: "재판의 흐름을 아는 판사출신변호사",
    desc: "25년 광주지방법원 부장판사퇴직으로 법원의 판단 기준을 정확히 파악합니다.",
  },
  {
    icon: "ri-scales-2-line",
    title: "대한변협등록 형사법전문변호사",
    desc: "대한변호사협회 등록 형사법전문변호사로서 형사사건만 전문적으로 다룹니다.",
  },
  {
    icon: "ri-shield-star-line",
    title: "검사출신변호사로서 수사단계부터",
    desc: "검사 경험을 바탕으로 수사 초기부터 유리한 방어 전략을 세웁니다.",
  },
  {
    icon: "ri-hand-heart-line",
    title: "의뢰인 중심의 책임감있는 변호",
    desc: "의뢰인의 자유와 권리를 지키기 위해 끝까지 책임 있게 함께합니다.",
  },
];

const process = [
  { step: "01", title: "사건 접수 · 무료 상담", desc: "사건 내용 파악 및 예상 쟁점 제시" },
  { step: "02", title: "수사기록 · 증거 분석", desc: "판사 출신 시각의 정밀한 기록 분석" },
  { step: "03", title: "방어 전략 수립", desc: "무죄·선처·감경 등 맞춤 전략 설계" },
  { step: "04", title: "재판 · 집행 대응", desc: "변론부터 집행유예·선고까지 동행" },
];

export default function CriminalWhy() {
  return (
    <section className="py-16 md:py-24 bg-background-100">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-stretch">
          <div className="flex flex-col">
            <p className="inline-flex w-44 items-center justify-center gap-2 rounded-full bg-primary-50 px-4 py-1.5 text-xs font-medium text-primary-700 tracking-wide">
              <i className="ri-star-smile-line"></i>
              WHY KIM PYUNGHO
            </p>
            <h2 className="mt-5 font-heading text-2xl md:text-4xl font-bold text-foreground-950 leading-snug">
              광주판사·검사출신변호사,
              <br />
              <span className="text-accent-600">왜 김평호 변호사인가요?</span>
            </h2>
            <p className="mt-4 text-sm md:text-base text-foreground-600 leading-relaxed">
              판사·검사로 재판과 수사를 직접 경험한 변호사는 어떤 증거가 인정되고
              어떤 논리가 받아들여지는지를 법원의 시선으로 미리 준비합니다.
              그 경륜이 의뢰인에게 가장 강력한 방패가 됩니다.
            </p>

            <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 gap-4 flex-1 auto-rows-fr">
              {reasons.map((r) => (
                <div
                  key={r.title}
                  className="flex items-center gap-3 rounded-lg bg-white border border-background-200 px-5 py-4 transition-colors hover:border-accent-400 hover:bg-accent-50"
                >
                  <span className="flex items-center justify-center w-10 h-10 shrink-0 rounded-md bg-accent-500 text-white">
                    <i className={`${r.icon} text-lg`}></i>
                  </span>
                  <p className="text-sm font-semibold text-foreground-900 leading-snug">{r.title}</p>
                </div>
              ))}
            </div>
          </div>

          <div className="flex flex-col">
            <p className="inline-flex w-44 items-center justify-center gap-2 rounded-full bg-primary-50 px-4 py-1.5 text-xs font-medium text-primary-700 tracking-wide">
              <i className="ri-flow-chart"></i>
              PROCESS
            </p>
            <h3 className="mt-5 font-heading text-2xl md:text-3xl font-bold text-foreground-950 leading-snug">
              형사사건 대응 프로세스
            </h3>
            <p className="mt-3 text-sm md:text-base text-foreground-600 leading-relaxed">
              접수부터 재판까지, 단계별 전략으로 끝까지 함께합니다.
            </p>

            <div className="mt-8 flex flex-1 flex-col">
              {process.map((p, idx) => (
                <div key={p.step} className="flex gap-4 lg:flex-1">
                  <div className="flex flex-col items-center">
                    <span className="flex items-center justify-center w-10 h-10 shrink-0 rounded-full bg-primary-500 text-sm font-bold text-white">
                      {p.step}
                    </span>
                    {idx < process.length - 1 && (
                      <span className="mt-1 w-px flex-1 bg-background-300"></span>
                    )}
                  </div>
                  <div className="flex-1 pt-1 pb-6 lg:pb-0">
                    <p className="text-base font-semibold text-foreground-950">{p.title}</p>
                    <p className="mt-1 text-sm text-foreground-600 leading-relaxed">{p.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}